import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {HelpModule} from "../../components/help/help.module";
import {PruefungKundePage} from "./pruefung-kunde";

@NgModule({
  declarations: [
    PruefungKundePage,
  ],
  entryComponents: [
    PruefungKundePage,
  ],
  imports: [
    IonicPageModule.forChild(PruefungKundePage),
    HelpModule
  ]
})
export class PruefungKundeModule {}



// WEBPACK FOOTER //
// ./src/pages/pruefung-kunde/pruefung-kunde.module.ts